import { FingerprintJSPro, FpjsProvider } from '@fingerprintjs/fingerprintjs-pro-react'
import { WrapRootElementBrowserArgs } from 'gatsby'
import React, { ReactNode } from 'react'

const apiKey = process.env.GATSBY_FPJS_API_KEY
if (!apiKey) {
  throw console.log('missing api keys')
}

export const wrapRootElement = ({ element }: WrapRootElementBrowserArgs) => (
  <FpjsProvider
    loadOptions={{
      apiKey,
      region: 'us',
      scriptUrlPattern: [
        'https://mealpal.com/9gOWxCHfRiqQzUxi/IKd7kFqdUAq21jgB?apiKey=<apiKey>',
        FingerprintJSPro.defaultScriptUrlPattern,
      ],
      endpoint: ['https://mealpal.com/9gOWxCHfRiqQzUxi/njXD2N4ont8sEuup', 'https://api.fpjs.io'],
    }}
  >
    {element}
  </FpjsProvider>
)
